import { render } from "./EachPlantPage.vue?vue&type=template&id=ecfd5ce8&scoped=true&ts=true"
import script from "./EachPlantPage.vue?vue&type=script&lang=ts"
export * from "./EachPlantPage.vue?vue&type=script&lang=ts"

import "./EachPlantPage.vue?vue&type=style&index=0&id=ecfd5ce8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3546012314/src/biomass-frontend-poc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecfd5ce8"]])

export default __exports__